import { connect } from 'dva';
import config from '../../config';

function WithMarkIspPermissions({ children, currentUser }) {
  const hasPermissions = () => {
    return config['features.mark_as_isp'] && config['features.mark_as_isp_emails'].includes(currentUser.email);
  };

  if (hasPermissions()) {
    return children;
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.app.user,
  };
};

export default connect(mapStateToProps)(WithMarkIspPermissions);



// WEBPACK FOOTER //
// ./src/components/Permissions/WithMarkIspPermissions.js